// Maps icon identifiers to Lucide icon components for the React client
import { MessageSquare, FileText, Globe, Mail, HelpCircle, Video, Wrench, LayoutGrid } from 'lucide-react'
import type { IconIdentifier } from '@/lib/content/contentTypes'

export const iconMapping = {
    'message-square': MessageSquare,
    'file-text': FileText,
    'globe': Globe,
    'mail': Mail,
    'help-circle': HelpCircle,
    'video': Video,
    'wrench': Wrench,
    'layout-grid': LayoutGrid,
} as const

export function getIcon(iconName: IconIdentifier) {
    return iconMapping[iconName]
} 